import { Spinner } from "@nextui-org/react";

import { Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

type BlockedCreatorsEmptyStateProps = {
  isAuthenticated: boolean;
  isInitialLoading: boolean;
  "data-testid"?: string;
};

const BlockedCreatorsEmptyState = ({
  isAuthenticated,
  isInitialLoading,
  "data-testid": testId = "BlockedCreatorsEmptyState",
}: BlockedCreatorsEmptyStateProps) => {
  if (!isAuthenticated) {
    return (
      <Row className="p-5 justify-center" data-testid={testId}>
        <Text>
          <Trans i18nKey="creator:page.blocked.notLoggedIn" />
        </Text>
      </Row>
    );
  }

  if (isInitialLoading) {
    return (
      <Row className="p-5 justify-center" data-testid={testId}>
        <Spinner size="sm" />
      </Row>
    );
  }

  return (
    <Row className="p-5 justify-center" data-testid={testId}>
      <Text>
        <Trans i18nKey="creator:page.blocked.emptyState" />
      </Text>
    </Row>
  );
};

export default BlockedCreatorsEmptyState;
